<template>
  <div style="text-align:center">
    <p>
      Выполнение сценария <b>'{{ scenarioLabel }}'</b> успешно закончено.
    </p>
    <span v-if="showPassed">
        <span v-if="isPassed">
          <p>
            Вы набрали необходимое число баллов (больше 50 процентов).
          </p>
          <p>
            Теперь у вас есть полный доступ к функционалу Личного Кабинета.
          </p>
        </span>
        <span v-else>
          <p>
            Вы не набрали необходимое число баллов (меньше 50 процентов).
          </p>
        </span>
      </p>
    </span>
    <p>
      Нажмите <b>'Выход'</b> для завершения работы.
    </p>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import { mapGetters } from 'vuex'

  export default {
      name: 'scenarioexit',
      data() {
        return {

        }
      },
      computed: {
        ...mapGetters([
          'scenarioLabel',
          'isContestAuthorized',
          'showPassed',
          'isPassed'
        ])
      },
      created() {
        if(!this.isContestAuthorized)
          this.$router.push(config.WELCOME_URL);
      }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/contest/scenarioexit.vue